export default __webpack_public_path__ + "static/media/logo.d26afe4b.png";